import { SubscriptionManagerService } from '@weave/schema-gen-ts/dist/schemas/subscription-manager-service/v1/subscription_manager_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaSubscriptionManagerV1Service = bindHTTP(SubscriptionManagerService);
export const serviceName = 'subscription-manager-v1' as const;
